function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-140.96875 0-256 115.050781-256 256 0 140.96875 115.050781 256 256 256 140.96875 0 256-115.050781 256-256 0-140.96875-115.050781-256-256-256zm0 482c-124.617188 0-226-101.382812-226-226s101.382812-226 226-226 226 101.382812 226 226-101.382812 226-226 226zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(247, 223, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211 376c0 24.8125 20.1875 45 45 45s45-20.1875 45-45-20.1875-45-45-45-45 20.1875-45 45zm45-15c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(247, 223, 69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 91c-57.898438 0-105 47.101562-105 105v15h90v-15c0-8.269531 6.730469-15 15-15s15 6.730469 15 15c0 5.53125-3.046875 10.605469-7.96875 13.25-32.09375 17.300781-52.03125 51.996094-52.03125 90.550781v31.199219h90v-31.199219c0-5.695312 2.425781-10.070312 4.703125-11.300781 34.109375-18.351562 55.296875-53.796875 55.296875-92.5 0-57.898438-47.101562-105-105-105zm35.488281 171.085938c-12.636719 6.800781-20.488281 21.253906-20.488281 37.714843v1.199219h-30v-1.199219c0-27.507812 13.894531-52.082031 36.25-64.132812 14.648438-7.871094 23.75-23.074219 23.75-39.667969 0-24.8125-20.1875-45-45-45-19.558594 0-36.238281 12.539062-42.429688 30h-31.0625c6.96875-34.191406 37.273438-60 73.492188-60 41.355469 0 75 33.644531 75 75 0 27.648438-15.140625 52.96875-39.511719 66.085938zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(247, 223, 69)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9bfd71513bc8d637d2f966222c029c26.svg";
export { ForwardRef as ReactComponent };